export default {
  description:
    'FamilySearch International is the largest genealogy organization in the world and is a nonprofit, volunteer-driven organization sponsored by The Church of Jesus Christ of Latter-day Saints. Access is free at FamilySearch.org and through over 5,000 family history centers in 129 countries, including the FamilySearch Library in Salt Lake City, Utah.',
  sameAs:
    'https://www.facebook.com/familysearch/, https://www.facebook.com/familyhistorylibrary, https://www.facebook.com/FamilySearchUK, https://www.youtube.com/channel/UC7Aaf6jNp4OHQNGDTBbSZBA https://www.instagram.com/familysearch/, https://www.instagram.com/familysearcheurope/, https://twitter.com/familysearch, https://www.wikidata.org/wiki/Q3066228, https://en.wikipedia.org/wiki/FamilySearch, https://www.youtube.com/channel/UC-9GZ7QHKOmLS0APnfz2g1Q',
  homepageName: 'English Homepage',
  publisher: {
    parentOrganization: {
      name: 'The Church of Jesus Christ of Latter-day Saints',
    },
  },
}
